export default "__VITE_ASSET__d91d3c0d__"